import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const fetchAbout = createAsyncThunk('aboutSlice/fetchAbout', async () => {
    const res = await fetch(`${process.env.REACT_APP_PROJECTS_API}components/s_d.php?about`)
    const data = await res.json()
    return data;
})

const aboutSlice = createSlice({
    initialState: {
        about: [],
        loading: false,
        error: null,
    },
    name: 'aboutSlice',
    extraReducers: (builder) => {
        builder
            .addCase(fetchAbout.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAbout.fulfilled, (state, action) => {
                state.loading = false;
                state.about = action.payload;
            })
            .addCase(fetchAbout.rejected, (state, action) => {
                state.loading = false;
                state.error = <p className='error-api'>The server is temporarily down Please try later!</p>;
            });
    },
})

export const { } = aboutSlice.actions;

export default aboutSlice.reducer;